import React, { useEffect, useState } from 'react'
import { Delete_ObjectInstance_Api, GetAll_Paging_ObjectInstance_Api } from '../../API/ObjectInstanceApi';
import { Button, Col, Modal, Pagination, Row } from 'antd';
import { DeleteOutlined, ToolOutlined, GroupOutlined, EditOutlined, PlusOutlined
    , RollbackOutlined, CloseOutlined, DoubleRightOutlined } from '@ant-design/icons';
import { ConfigProvider } from 'antd';
import faIR from 'antd/locale/fa_IR';
// =================================================================
export const AllObjectInstanceComponent = ({ 
    objectTypeId, 
    objectTypeTitle, 
    setLoading, 
    showMessage, 
    currentPage, 
    setCurrentPage, 
    version, 
    onAddClick, 
    onEdit, 
    onRowDeleted, 
    onSetObjectFieldValues, 
    onCategoryClick, 
    onBackClick,
    onOutOfService      // <-- جدید
}) => {
    // =================================================================
    const [objectInstances, setObjectInstances] = useState([]);
    const [pageCount, setPageCount] = useState(4);
    
    // =================================================================
    useEffect(() => {
        loadObjectInstances();
    }, [objectTypeId, currentPage, version]);
    // =================================================================
    const loadObjectInstances = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Paging_ObjectInstance_Api({ pageNumber: currentPage, objectTypeId: objectTypeId });
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPageCount(data.messageData.pageCount * 10)
                setObjectInstances(data.messageData.data);
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const deleteRow = async (id) => {
        setLoading(true);
        try {
            let data = await Delete_ObjectInstance_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful");
                onRowDeleted();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
const onOutOfServiceClick=(id,title)=>{
    onOutOfService(id,title);
}
   
    // ======================================================================
    return (
        <>
            <Row className='sectionTitle'>
                <Col xs={6} sm={6} md={6} lg={4} xl={4} style={{ textAlign: "right" }} >
                    <Button onClick={() => onBackClick()}>
                        <DoubleRightOutlined />
                        بازگشت
                    </Button>
                </Col>
                <Col xs={10} sm={10} md={10} lg={14} xl={14}>
                    <h2 >
                        {objectTypeTitle}
                    </h2>
                </Col>
                <Col xs={8} sm={8} md={8} lg={6} xl={6} style={{ textAlign: "left" }}>
                    <Button className='btn-primary' onClick={() => onAddClick()} >
                        <PlusOutlined />
                        ایجاد رکورد جدید</Button>
                </Col>
            </Row>
            <div className='container'>
                {objectInstances.map((objectInstance, key) =>
                    <>
                        <Row key={key} className="valueRow">
                            <Col span={5} style={{ padding: "5px" }}>  {objectInstance.title} </Col>
                            <Col span={19} style={{ textAlign: "left" }}>
                                <Button className='btn-success' style={{ marginLeft: "2px" }} onClick={() => onEdit(objectInstance.id)}>
                                    <EditOutlined />
                                    ویرایش
                                </Button>
                                <Button className='btn-info' style={{ marginLeft: "2px" }} onClick={() => onSetObjectFieldValues(objectInstance.id)}>
                                    <ToolOutlined />
                                    خاصیت ها
                                </Button>
                                <Button className='btn-secondary' style={{ marginLeft: "2px" }} onClick={() => onCategoryClick(objectInstance.id)}>
                                    <GroupOutlined />
                                    دسته بندی
                                </Button>
                                <Button
    className="btn-warning"
    style={{ marginLeft: "2px" }}
    //onClick={() => onOutOfServiceClick(objectInstance.id)}
    onClick={() => onOutOfServiceClick(objectInstance.id, objectInstance.title)}
>
    <ToolOutlined />
    خارج از سرویس
</Button>
                                <Button
                                    className='btn-danger'
                                    onClick={() => {
                                        Modal.confirm({
                                            title: 'آیا از حذف ' + objectInstance.title + ' اطمینان دارید؟',
                                            onOk: () => { deleteRow(objectInstance.id) },
                                            footer: (_, { OkBtn, CancelBtn }) => (
                                                <>
                                                    <CancelBtn />
                                                    <OkBtn />
                                                </>
                                            ),
                                        });
                                    }}
                                >
                                    <DeleteOutlined />
                                    حذف
                                </Button>
                            </Col>
                        </Row>
                    </>
                )}
            </div>
<ConfigProvider direction="rtl" locale={faIR}>
            <Pagination
               showSizeChanger={false} 
                            showQuickJumper={false} 
            current={currentPage} align="center" onChange={(page) => setCurrentPage(page)} total={pageCount} />
</ConfigProvider>
        </>
    )
}